"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractFriends = exports.FriendList = void 0;
var _solidUi = require("solid-ui");
var _litHtml = require("lit-html");
require("./styles/FriendList.css");
const FriendList = (subject, context) => {
  const friends = extractFriends(subject, context);
  if (!friends || !friends.textContent?.trim()) return null;
  return (0, _litHtml.html)`
    <section
      class="friendListSection"
      role="region"
      aria-labelledby="friends-section-title"
      data-testid="friend-list"
    >
      <nav aria-label="Friend profiles">
        <ul class="list-reset zebra-stripe" role="list">
          ${friends}
        </ul>
      </nav>
    </section>
  `;
};
exports.FriendList = FriendList;
const extractFriends = (subject, {
  dom
}) => {
  const target = dom.createElement('div');
  _solidUi.widgets.attachmentList(dom, subject, target, {
    doc: subject.doc(),
    modify: false,
    predicate: _solidUi.ns.foaf('knows'),
    noun: 'friend'
  });
  if (target.textContent === '') return null;
  // Add 'friendItem' class and unique aria-label to each <li> for accessibility
  target.querySelectorAll('li').forEach((li, idx) => {
    li.classList.add('friendItem');
    // Try to find a link or text to use as a label
    const link = li.querySelector('a');
    if (link && link.textContent) {
      li.setAttribute('aria-label', `Friend: ${link.textContent.trim()}`);
    } else if (li.textContent) {
      li.setAttribute('aria-label', `Friend: ${li.textContent.trim()}`);
    } else {
      li.setAttribute('aria-label', `Friend ${idx + 1}`);
    }
  });
  return target;
};
exports.extractFriends = extractFriends;